import React from "react";
import { StyleSheet, Text } from "react-native";

import BaseItemCard from "@/Components/Cards/BaseItemCard";
import { Spacings } from "@/styling/spacings";
import { themes } from "@/Components/Styling/themeConfigs";

const currentTheme = themes.morning;

type Props = {
  iconComponent: React.JSX.Element;
  title: string;
  description: string;
};

function PremiumFeatureBaseCard({
  iconComponent,
  title,
  description,
}: Props): React.JSX.Element {
  const infoComponent = (
    <>
      <Text style={styles.bold}>{title}</Text>
      <Text>{description}</Text>
    </>
  );

  return (
    <BaseItemCard
      leftComponent={iconComponent}
      infoComponent={infoComponent}
      rightComponent={<></>}
      additionalStyle={styles.container}
    />
  );
}

const styles = StyleSheet.create({
  bold: {
    fontWeight: "bold",
  },
  container: {
    paddingHorizontal: Spacings.s3,
    marginVertical: Spacings.s1,
    backgroundColor: "#f5f5f5",
    borderRadius: 8,
    borderWidth: 0.5,
    borderStyle: "solid",
    borderColor: currentTheme.borderColor,
  },
});

export default PremiumFeatureBaseCard;
